import React, { useState } from 'react';
import {
  Box,
  Container,
  Typography,
  Paper,
  AppBar,
  Toolbar,
  Button,
  Avatar,
} from '@mui/material';
import { AccountCircle as AccountIcon } from '@mui/icons-material';
import { EtablissementSearch } from '../components/EtablissementSearch';
import { PhotoManager } from '../components/PhotoManager';
import { Etablissement } from '../types';
import { useAuth } from '../contexts/AuthContext';

export const HomePage: React.FC = () => {
  const { user, isAuthenticated, login, logout } = useAuth();
  const [selectedEtablissement, setSelectedEtablissement] = useState<Etablissement | null>(null);

  const handleEtablissementSelect = (etablissement: Etablissement) => {
    setSelectedEtablissement(etablissement);
  };

  const handleBackToSearch = () => {
    setSelectedEtablissement(null);
  };

  // if (!isAuthenticated) {
  //   return (
  //     <Box sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
  //       <Container maxWidth="sm">
  //         <Paper sx={{ p: 4, textAlign: 'center' }}>
  //           <Typography variant="h4" gutterBottom>
  //             PPMS Photos Manager
  //           </Typography>
  //           <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
  //             Application de gestion des photos PPMS
  //           </Typography>
  //           <Button
  //             variant="contained"
  //             size="large"
  //             onClick={login}
  //           >
  //             Se connecter
  //           </Button>
  //         </Paper>
  //       </Container>
  //     </Box>
  //   );
  // }

  return (
    <Box sx={{ minHeight: '100vh' }}>
      {/* Header */}
      {/* <AppBar position="static">
        <Toolbar>
          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
            PPMS Photos Manager
          </Typography>
          {user && (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Typography variant="body2">
                {user.name}
              </Typography>
              <Avatar sx={{ width: 32, height: 32 }}>
                {user.picture ? (
                  <img src={user.picture} alt={user.name} />
                ) : (
                  <AccountIcon />
                )}
              </Avatar>
              <Button color="inherit" onClick={logout}>
                Déconnexion
              </Button>
            </Box>
          )}
        </Toolbar>
      </AppBar> */}
      <AppBar position="static" color="transparent" elevation={0}>
        <Container
          maxWidth="lg"
          sx={{
            bgcolor: 'white',
            height: 100,
            display: 'flex',
            alignItems: 'center',
            flexDirection: 'row',
            px: 2
          }}
        >
          {/* Logo à gauche */}
          <Box sx={{ display: 'flex', alignItems: 'center', mr: 2 }}>
            <img
              src="/AMIEQ FRANCE - CERTIFIEE ISO.png"
              alt="AMIEQ France"
              style={{ height: 96, cursor: 'pointer' }}
              onClick={() => {
                setSelectedEtablissement(null);
                window.scrollTo({ top: 0, behavior: 'smooth' });
              }}
            />
          </Box>
          {/* Titre à gauche, à côté du logo */}
          <Typography
            variant="h4"
            component="div"
            sx={{ color: 'primary.main', fontWeight: 'bold', ml: 2 }}
          >
            PPMS Photos Manager
          </Typography>
        </Container>
      </AppBar>

      {/* Contenu principal */}
      <Container maxWidth="lg" sx={{ mt: 3 }}>
        {selectedEtablissement ? (
          <Box>
            <PhotoManager etablissement={selectedEtablissement} />
          </Box>
        ) : (
          <EtablissementSearch onEtablissementSelect={handleEtablissementSelect} />
        )}
      </Container>
    </Box>
  );
}; 